import { string } from '@treasury/FDL';
import { enumeration } from './primitives';

export const company = string.with.formatter(value => value.companyName);

export const companyName = string;

export const secCode = enumeration.with.exampleValue('PPD');
